class FacetedCatalog extends HTMLElement {
 connectedCallback() {
  if (this.bound) return;
  this.bound = true;
  this.version = 0;
  this.form = this.querySelector('[data-facet-form]');
  this.dialog = this.querySelector('.facet-drawer');
  this.exactColorDialog = this.querySelector('.occasion-color-drawer');
  this.classList.add('facets-enhanced');
  this.addEventListener('toggle', e => {
   const group = e.target.closest?.('[data-filter-group]');
   if (innerWidth > 900 || !group?.open || !this.dialog?.contains(group)) return;
   this.form?.querySelectorAll('[data-filter-group][open]').forEach(other => {
    if (other !== group) other.open = false;
   });
  }, true);
  this.addEventListener('input', e => {
   if (!e.target.closest('[data-price-range]')) return;
   this.invalidate();
   this.syncPrice(e.target.closest('[data-price-range]'), e.target);
   if (e.target.type === 'number') this.timer = setTimeout(() => this.apply(), 650);
  });
  this.addEventListener('change', e => {
   if (e.target.matches('[data-sort]') || e.target.closest('[data-facet-form]')) {
    this.invalidate();
    this.timer = setTimeout(() => this.apply({colorChanged: e.target.matches('[data-color-slug]')}), e.target.type === 'range' ? 200 : 0);
   }
  });
  this.addEventListener('submit', e => {
   if (e.target === this.form) { e.preventDefault(); this.apply(); }
  });
  this.addEventListener('click', e => {
   const family = e.target.closest('[data-occasion-family]');
   const secondary = e.target.closest('[data-occasion-secondary]');
   const exactColor = e.target.closest('[data-occasion-exact-color]');
   const removeFilter = e.target.closest('[data-occasion-remove-filter]');
   if (removeFilter) { e.preventDefault(); location.assign(this.preserveColorState(removeFilter.href)); return; }
   if (family) { e.preventDefault(); location.assign(this.familyURL(family)); return; }
   if (exactColor) { e.preventDefault(); location.assign(this.exactColorURL(exactColor)); return; }
   if (secondary) { e.preventDefault(); location.assign(this.preserveColorState(secondary.href)); return; }
   if (e.target.closest('[data-occasion-clear-color]')) { e.preventDefault(); location.assign(this.clearColorURL()); return; }
   if (e.target.closest('[data-more-colors]')) { e.preventDefault(); this.openExactColors(); return; }
   if (e.target.closest('[data-color-drawer-close]')) { e.preventDefault(); this.closeExactColors(); return; }
   if (e.target === this.exactColorDialog) { this.closeExactColors(); return; }
   if (e.target.closest('[data-filter-open]')) this.open();
   if (e.target.closest('[data-filter-close], [data-filter-done]')) this.close();
   if (e.target.closest('[data-clear-filters]')) {
    e.preventDefault();
    this.form?.querySelectorAll('input[name^="filter."]').forEach(i => {
     i.setCustomValidity('');
     if (i.type === 'checkbox') i.checked = false; else i.value = '';
    });
    this.initPrices();
    this.apply({clearAll: true});
   }
  });
  this.dialog?.addEventListener('cancel', e => { e.preventDefault(); this.close(); });
  this.dialog?.addEventListener('click', e => { if (e.target === this.dialog) this.close(); });
  this.bindExactColorDialog();
  this.onResize = () => {
   if (innerWidth <= 900) return;
   if (this.dialog?.open) this.close();
   this.form?.querySelectorAll('[data-filter-group]').forEach(group => { group.open = group.dataset.filterKind !== 'price'; });
  };
  this.onPop = () => location.reload();
  window.addEventListener('resize', this.onResize);
  window.addEventListener('popstate', this.onPop);
  this.orderFilters();
  this.initPrices();
  this.hydrateOccasionQuickFilters();
 }
 disconnectedCallback() {
  this.invalidate();
  window.removeEventListener('resize', this.onResize);
  window.removeEventListener('popstate', this.onPop);
  document.documentElement.classList.remove('dialog-open');
 }
 invalidate() {
  clearTimeout(this.timer);
  this.controller?.abort();
  this.version++;
  this.querySelector('[data-results]')?.removeAttribute('aria-busy');
  const status = this.querySelector('[data-filter-status]');
  if (status) status.textContent = '';
 }
 open() {
  if (!this.form || !this.dialog || this.dialog.open) return;
  this.closeExactColors();
  this.trigger = document.activeElement;
  this.querySelector('[data-filter-body]').append(this.form);
  const groups = [...this.form.querySelectorAll('[data-filter-group]')];
  groups.forEach(group => { group.open = false; });
  const activeGroup = groups.find(group => group.querySelector('input[type="checkbox"]:checked, input[type="number"][value]:not([value=""])'));
  (activeGroup || groups[0])?.setAttribute('open', '');
  this.dialog.showModal();
  document.documentElement.classList.add('dialog-open');
 }
 close() {
  if (!this.dialog?.open) return;
  this.dialog.close();
  this.querySelector('[data-filter-home]').append(this.form);
  if (!this.exactColorDialog?.open) document.documentElement.classList.remove('dialog-open');
  this.trigger?.focus({preventScroll:true});
 }
 bindExactColorDialog() {
  this.exactColorDialog = this.querySelector('.occasion-color-drawer');
  if (!this.exactColorDialog || this.exactColorDialog.dataset.bound === 'true') return;
  this.exactColorDialog.dataset.bound = 'true';
  this.exactColorDialog.addEventListener('cancel', e => { e.preventDefault(); this.closeExactColors(); });
 }
 openExactColors() {
  this.bindExactColorDialog();
  if (!this.exactColorDialog || this.exactColorDialog.open) return;
  if (this.dialog?.open) this.close();
  this.colorTrigger = document.activeElement;
  this.exactColorDialog.showModal();
  document.documentElement.classList.add('dialog-open');
 }
 closeExactColors() {
  if (!this.exactColorDialog?.open) return;
  this.exactColorDialog.close();
  if (!this.dialog?.open) document.documentElement.classList.remove('dialog-open');
  this.colorTrigger?.focus({preventScroll:true});
 }
 openColorFilters() {
  const quick = this.querySelector('.occasion-quick');
  const param = quick?.dataset.colorParam || 'filter.v.option.color';
  if (innerWidth <= 900) this.open();
  const group = [...this.querySelectorAll('[data-filter-group]')].find(node => node.dataset.filterGroup === param || node.dataset.filterGroup.includes('.color'));
  if (!group) return;
  group.open = true;
  group.querySelector('summary')?.focus({preventScroll:true});
  if (innerWidth > 900) group.scrollIntoView({behavior:'smooth',block:'start'});
 }
 orderFilters() {
  if (!this.form || !this.classList.contains('catalog--collection')) return;
  const groups = [...this.form.querySelectorAll('[data-filter-group]')];
  const anchor = this.form.querySelector('.facet-actions');
  groups.sort((a, b) => Number(a.dataset.facetRank || 50) - Number(b.dataset.facetRank || 50));
  groups.forEach(group => this.form.insertBefore(group, anchor));
 }
 initPrices() {
  this.querySelectorAll('[data-price-range]').forEach(g => this.syncPrice(g));
 }
 syncPrice(g, changed) {
  const min = g.querySelector('[data-price-min]');
  const max = g.querySelector('[data-price-max]');
  const low = g.querySelector('[data-range-min]');
  const high = g.querySelector('[data-range-max]');
  const limit = Number(g.dataset.priceRange);
  min.setCustomValidity(''); max.setCustomValidity('');
  if (changed === low) min.value = Math.min(Number(low.value), max.value === '' ? limit : Number(max.value)).toFixed(2);
  if (changed === high) max.value = Math.max(Number(high.value), min.value === '' ? 0 : Number(min.value)).toFixed(2);
  const a = min.value === '' ? 0 : Number(min.value);
  const b = max.value === '' ? limit : Number(max.value);
  if (a > b) min.setCustomValidity('Minimum price must not exceed maximum price.');
  low.value = Math.max(0, Math.min(limit, a));
  high.value = Math.max(0, Math.min(limit, b));
  low.setAttribute('aria-valuemax', String(b));
  high.setAttribute('aria-valuemin', String(a));
  low.setAttribute('aria-valuetext', g.dataset.currency + ' ' + a.toFixed(2));
  high.setAttribute('aria-valuetext', g.dataset.currency + ' ' + b.toFixed(2));
  low.style.zIndex = a >= limit ? '3' : '1';
  g.style.setProperty('--range-start', (limit ? a / limit * 100 : 0) + '%');
  g.style.setProperty('--range-end', (limit ? b / limit * 100 : 0) + '%');
  g.querySelector('[data-price-values]').textContent = g.dataset.currency + ' ' + a.toFixed(2) + ' – ' + b.toFixed(2);
 }
 colorParam() {
  return this.querySelector('.occasion-quick')?.dataset.colorParam || 'filter.v.option.color';
 }
 clearColorURL() {
  const u = new URL(location.href);
  u.searchParams.delete('page');
  u.searchParams.delete('color');
  u.searchParams.delete('color_family');
  u.searchParams.delete(this.colorParam());
  return u.href;
 }
 familyURL(link) {
  const u = new URL(location.href);
  const family = link.dataset.occasionFamily;
  const isActive = u.searchParams.get('color_family') === family;
  u.searchParams.delete('page');
  u.searchParams.delete('color');
  u.searchParams.delete('color_family');
  u.searchParams.delete(this.colorParam());
  if (!isActive) {
   u.searchParams.set('color_family', family);
   (link.dataset.colorValues || '').split('||').filter(Boolean).forEach(value => u.searchParams.append(this.colorParam(), value));
  }
  return u.href;
 }
 exactColorURL(option) {
  const u = new URL(location.href);
  u.searchParams.delete('page');
  u.searchParams.delete('color');
  u.searchParams.delete('color_family');
  u.searchParams.delete(this.colorParam());
  u.searchParams.set('color', option.dataset.colorSlug);
  u.searchParams.append(this.colorParam(), option.dataset.colorValue);
  return u.href;
 }
 preserveColorState(href) {
  const current = new URL(location.href);
  const next = new URL(href, location.origin);
  ['color','color_family','quick_entry','preview_theme_id'].forEach(key => {
   if (current.searchParams.has(key)) next.searchParams.set(key, current.searchParams.get(key));
  });
  next.searchParams.delete('page');
  const hasAttribute = [...next.searchParams.keys()].some(key => key.startsWith('filter.') && key !== this.colorParam());
  if (!hasAttribute) next.searchParams.delete('quick_entry');
  return next.href;
 }
 hydrateOccasionQuickFilters() {
  const quick = this.querySelector('.occasion-quick');
  if (!quick) return;
  this.bindExactColorDialog();
  const params = new URLSearchParams(location.search);
  const family = params.get('color_family');
  const slug = params.get('color');
  const nativeColors = params.getAll(this.colorParam()).flatMap(value => value.split(',')).filter(Boolean);
  const hasColor = Boolean(family || slug || nativeColors.length);
  quick.querySelectorAll('[data-occasion-family]').forEach(link => {
   const active = link.dataset.occasionFamily === family;
   link.classList.toggle('is-active', active);
   link.setAttribute('aria-pressed', String(active));
   link.href = this.familyURL(link);
  });
  quick.querySelectorAll('[data-occasion-exact-color]').forEach(option => {
   const active = option.dataset.colorSlug === slug || nativeColors.includes(option.dataset.colorValue);
   option.classList.toggle('is-active', active);
   option.setAttribute('aria-pressed', String(active));
  });
  const selected = quick.querySelector('[data-occasion-selected]');
  const colorState = quick.querySelector('[data-occasion-selected-color]');
  if (colorState) {
   colorState.replaceChildren();
   colorState.hidden = !hasColor;
   if (hasColor) {
    let label = family || nativeColors.join(', ');
    if (slug) label = quick.querySelector(`[data-occasion-color-map] [data-color-slug="${CSS.escape(slug)}"]`)?.dataset.colorName || slug.replaceAll('-', ' ');
    const chip = document.createElement('a');
    chip.href = this.clearColorURL();
    chip.dataset.occasionClearColor = '';
    chip.className = 'occasion-quick__selected-chip';
    chip.textContent = label + ' ×';
    chip.setAttribute('aria-label', (quick.dataset.removeLabel || 'Remove') + ' ' + label);
    colorState.append(chip);
   }
  }
  const attributes = [...quick.querySelectorAll('[data-occasion-remove-filter]')];
  attributes.forEach(link => { link.href = this.preserveColorState(link.href); });
  if (selected) selected.hidden = !hasColor && !attributes.length;
  const colorGroup = quick.querySelector('.occasion-quick__group--color');
  if (colorGroup) colorGroup.hidden = false;
  const secondary = quick.querySelector('.occasion-quick__group--secondary');
  const secondaryParam = quick.dataset.secondaryParam;
  const otherAttribute = attributes.some(link => link.dataset.filterParam !== secondaryParam);
  if (secondary) secondary.hidden = params.get('quick_entry') === 'attribute' || otherAttribute;
  if (params.get('choose_color') === '1') {
   const clean = new URL(location.href);
   clean.searchParams.delete('choose_color');
   history.replaceState(history.state, '', clean);
   this.openExactColors();
  }
 }

 url({colorChanged = false, clearAll = false} = {}) {
  const u = new URL(location.href);
  const currentFamily = u.searchParams.get('color_family');
  const currentColor = u.searchParams.get('color');
  const currentColorValues = u.searchParams.getAll(this.colorParam());
  u.searchParams.delete('page'); u.searchParams.delete('section_id');
  [...u.searchParams.keys()].filter(k => k.startsWith('filter.')).forEach(k => u.searchParams.delete(k));
  if (this.form) for (const [k,v] of new FormData(this.form)) {
   if (k === 'sort_by' || v === '') continue;
   if (k.startsWith('filter.')) u.searchParams.append(k,v); else u.searchParams.set(k,v);
  }
  const colors = this.form ? [...this.form.querySelectorAll('[data-color-slug]:checked')] : [];
  u.searchParams.delete('color');
  u.searchParams.delete('color_family');
  const families = [...new Set(colors.map(input => input.dataset.colorFamily).filter(Boolean))];
  if (currentFamily && families.length === 1 && families[0] === currentFamily) u.searchParams.set('color_family', currentFamily);
  else if (colors.length === 1) u.searchParams.set('color', colors[0].dataset.colorSlug);
  else if (colors.length > 1 && families.length === 1) u.searchParams.set('color_family', families[0]);
  if (!colorChanged && !clearAll && (currentColor || currentFamily)) {
   u.searchParams.delete('color'); u.searchParams.delete('color_family');
   if (currentColor) u.searchParams.set('color', currentColor);
   if (currentFamily) u.searchParams.set('color_family', currentFamily);
   u.searchParams.delete(this.colorParam());
   currentColorValues.forEach(value => u.searchParams.append(this.colorParam(), value));
  }
  if (clearAll) { u.searchParams.delete('color'); u.searchParams.delete('color_family'); u.searchParams.delete('quick_entry'); }
  const sort = this.querySelector('[data-sort]');
  if (sort) u.searchParams.set('sort_by', sort.value);
  return u;
 }
 focusKey(el) {
  if (!el || !this.contains(el)) return null;
  return {id:el.id, name:el.name, value:el.value, type:el.type, action:['data-clear-filters','data-show-results','data-sort','data-filter-done','data-filter-open'].find(a=>el.hasAttribute(a))};
 }
 restoreFocus(key) {
  if (!key) return;
  const nodes = [...this.querySelectorAll('input,select,button,a,summary')];
  const el = nodes.find(n => key.id ? n.id === key.id : key.action ? n.hasAttribute(key.action) : key.name && n.name === key.name && n.type === key.type && (n.type !== 'checkbox' || n.value === key.value));
  if (el && !el.disabled) el.focus({preventScroll:true});
 }
 async apply(options = {}) {
  this.invalidate();
  if (this.form && !this.form.reportValidity()) {
   const status = this.querySelector('[data-filter-status]');
   if (status) status.textContent = 'Please enter a valid price range. Results have not changed.';
   return;
  }
  const version = this.version;
  const u = this.url(options);
  const request = new URL(u);
  request.searchParams.set('section_id', this.dataset.section);
  this.controller = new AbortController();
  this.querySelector('[data-results]')?.setAttribute('aria-busy','true');
  const status = this.querySelector('[data-filter-status]');
  if (status) status.textContent = 'Updating results…';
  const error = this.querySelector('[data-filter-error]');
  if (error) error.textContent = '';
  this.classList.remove('facets-error');
  try {
   const response = await fetch(request, {signal:this.controller.signal});
   if (!response.ok) throw Error('Unable to update filters. Please try again.');
   const doc = new DOMParser().parseFromString(await response.text(),'text/html');
   const next = [...doc.querySelectorAll('faceted-catalog')].find(n=>n.dataset.section===this.dataset.section);
   if (!next?.querySelector('[data-results]') || !next.querySelector('[data-results-count]')) throw Error('Unable to load results. Please try again.');
   if (version !== this.version || !this.isConnected) return;
   const focus = this.focusKey(document.activeElement);
   const scroll = this.dialog?.scrollTop || 0;
   const groups = new Map([...this.querySelectorAll('[data-filter-group]')].map(g=>[g.dataset.filterGroup,g.open]));
   const nextForm = next.querySelector('[data-facet-form]');
   if (this.form && nextForm) this.form.innerHTML = nextForm.innerHTML;
   this.querySelector('[data-results]').innerHTML = next.querySelector('[data-results]').innerHTML;
   const count = this.querySelector('[data-results-count]');
   const nextCount = next.querySelector('[data-results-count]');
   count.textContent = nextCount.textContent; count.dataset.resultsCount = nextCount.dataset.resultsCount;
   const strip = this.querySelector('.catalog-colors');
   const nextStrip = next.querySelector('.catalog-colors');
   if (strip && nextStrip) strip.replaceWith(nextStrip);
   else if (strip) strip.remove();
   else if (nextStrip) this.prepend(nextStrip);
   this.querySelectorAll('[data-filter-group]').forEach(g=>{if(groups.has(g.dataset.filterGroup))g.open=groups.get(g.dataset.filterGroup);});
   this.orderFilters();
   this.initPrices();
   if (u.href !== location.href) history.pushState({},'',u);
   this.dataset.resultsPages = next.dataset.resultsPages;
   const pagination = this.querySelector('[data-catalog-pagination]');
   if (pagination) pagination.innerHTML = next.querySelector('[data-catalog-pagination]')?.innerHTML || '';
   this.hydrateOccasionQuickFilters();
   this.dispatchEvent(new CustomEvent('catalog:updated', {bubbles: true}));
   this.restoreFocus(focus);
   if (this.dialog?.open) this.dialog.scrollTop=scroll;
   if (status) status.textContent=count.textContent;
  } catch(e) {
   if (version !== this.version || e.name === 'AbortError') return;
   this.classList.add('facets-error');
   if (error) error.textContent=e.message;
   if (status) status.textContent='Results have not changed. Retry filters.';
  } finally {
   if (version === this.version) this.querySelector('[data-results]')?.removeAttribute('aria-busy');
  }
 }
}
if (!customElements.get('faceted-catalog')) customElements.define('faceted-catalog', FacetedCatalog);



